import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.function.bind";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import React, { cloneElement } from 'react';
export default function ResizableHeaderCell(_ref) {
  var children = _ref.children,
      column = _ref.column,
      onResize = _ref.onResize;

  function onMouseDown(event) {
    if (event.button !== 0) {
      return;
    }

    var currentTarget = event.currentTarget;

    var _currentTarget$getBou = currentTarget.getBoundingClientRect(),
        right = _currentTarget$getBou.right;

    var offset = right - event.clientX;

    if (offset > 11) {
      // +1px to account for the border size
      return;
    }

    var onMouseMove = function onMouseMove(event) {
      handleResize(event.clientX + offset, currentTarget);
    };

    var onMouseUp = function onMouseUp() {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    event.preventDefault();
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  }

  function onTouchStart(event) {
    var touch = event.changedTouches[0];
    var identifier = touch.identifier;
    var currentTarget = event.currentTarget;

    var _currentTarget$getBou2 = currentTarget.getBoundingClientRect(),
        right = _currentTarget$getBou2.right;

    var offset = right - touch.clientX;

    if (offset > 11) {
      // +1px to account for the border size
      return;
    }

    function getTouch(event) {
      for (var _iterator = _createForOfIteratorHelperLoose(event.changedTouches), _step; !(_step = _iterator()).done;) {
        var _touch = _step.value;
        if (_touch.identifier === identifier) return _touch;
      }

      return null;
    }

    var onTouchMove = function onTouchMove(event) {
      var touch = getTouch(event);

      if (touch) {
        handleResize(touch.clientX + offset, currentTarget);
      }
    };

    var onTouchEnd = function onTouchEnd(event) {
      var touch = getTouch(event);
      if (!touch) return;
      window.removeEventListener('touchmove', onTouchMove);
      window.removeEventListener('touchend', onTouchEnd);
    };

    window.addEventListener('touchmove', onTouchMove);
    window.addEventListener('touchend', onTouchEnd);
  }

  function handleResize(x, target) {
    var width = x - target.getBoundingClientRect().left;

    if (width > 0) {
      onResize(column, width);
    }
  }

  return /*#__PURE__*/cloneElement(children, {
    onMouseDown: onMouseDown,
    onTouchStart: onTouchStart,
    children: /*#__PURE__*/React.createElement(React.Fragment, null, children.props.children, /*#__PURE__*/React.createElement("div", {
      className: "rdg-header-cell-resizer"
    }))
  });
}